import { render, staticRenderFns } from "./assessments-step.vue?vue&type=template&id=78a36fd8&"
import script from "./assessments-step.vue?vue&type=script&lang=js&"
export * from "./assessments-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports